var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"helper-box"},[(_vm.icon)?_c('icon',{staticClass:"box-icon",attrs:{"name":_vm.icon,"theme":"","gradient":""}}):_vm._e(),_c('div',{staticClass:"box-content"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }